import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FindLoad } from 'utils';
import { Loader } from 'components';
import { claimActions } from 'store';
import { ClaimDetailInfo } from 'fragments';

const ACTION_TYPE = 'GET_CLAIM_BY_ID';

export const ClaimDetails = ({ climId, afterSuccess, onClose }) => {
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (climId) {
            dispatch(claimActions.getClaimById(climId));
            // if(RolePermission([PermissionList.CLAIM_FILE_READ?.code, PermissionList.CLAIM_FILE_MANAGE?.code])) {
            //     dispatch(claimActions.getClaimDocument(params.id))
            // }
        }
    }, [climId]);

    // if (!!loader.length) return <Loader />;

    return (
        <div className="claim-details-modal">
            {loader.length ?
                <Loader />
                :
                <ClaimDetailInfo climId={climId} afterSuccess={afterSuccess} onClose={onClose} />
            }
        </div>
    );
};
